

export const ROLES = [
  { value: "conselheiro", label: "Conselheiro" },
  { value: "diretor", label: "Diretor" },
];

export const ROLE_LABEL = { conselheiro: "Conselheiro", diretor: "Diretor" };

export const blankForm = () => ({
  name: "",
  email: "",
  phone: "",
  role: "conselheiro",
  password: "",
});
